const queryGearBrandTotal = params => {
  return `
  query queryGearBrandTotal(
    $itemPath: String = "/sitecore/content/lynkco-global-portal/Content/Gear",
    $language: String = "${params.lang}"
  ) {
    item(path: $itemPath, language:$language) {
      children {
        name
        fields(ownFields:true) {
          name
          value
        }
      }
    }  
  }
`;
};

export default queryGearBrandTotal;
